/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProcessDto } from '../models';
// @ts-ignore
import type { ProcessEventDto } from '../models';
// @ts-ignore
import type { ProcessEventIdDto } from '../models';
// @ts-ignore
import type { ProcessEventPropertiesDto } from '../models';
// @ts-ignore
import type { ProcessEventsPageableResponseDto } from '../models';
// @ts-ignore
import type { ProcessEventsSearchRequestDto } from '../models';
/**
 * RestProcessesEventBasicApi - axios parameter creator
 */
export const RestProcessesEventBasicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} processId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessEvent: async (processId: string, processEventPropertiesDto: ProcessEventPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createProcessEvent', 'processId', processId)
            // verify required parameter 'processEventPropertiesDto' is not null or undefined
            assertParamExists('createProcessEvent', 'processEventPropertiesDto', processEventPropertiesDto)
            const localVarPath = `/api/processes/{processId}/events`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processEventPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessByEventId: async (processEventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('getProcessByEventId', 'processEventId', processEventId)
            const localVarPath = `/api/events/{processEventId}/process`
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEvent: async (processId: string, processEventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessEvent', 'processId', processId)
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('getProcessEvent', 'processEventId', processEventId)
            const localVarPath = `/api/processes/{processId}/events/{processEventId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} processId 
         * @param {ProcessEventsSearchRequestDto} processEventsSearchRequestDto Process event search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEvents: async (page: number, pageSize: number, processId: string, processEventsSearchRequestDto: ProcessEventsSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getProcessEvents', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getProcessEvents', 'pageSize', pageSize)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessEvents', 'processId', processId)
            // verify required parameter 'processEventsSearchRequestDto' is not null or undefined
            assertParamExists('getProcessEvents', 'processEventsSearchRequestDto', processEventsSearchRequestDto)
            const localVarPath = `/api/processes/{processId}/events-search`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processEventsSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessEvent: async (processId: string, processEventId: number, processEventPropertiesDto: ProcessEventPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessEvent', 'processId', processId)
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('updateProcessEvent', 'processEventId', processEventId)
            // verify required parameter 'processEventPropertiesDto' is not null or undefined
            assertParamExists('updateProcessEvent', 'processEventPropertiesDto', processEventPropertiesDto)
            const localVarPath = `/api/processes/{processId}/events/{processEventId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processEventPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessesEventBasicApi - functional programming interface
 */
export const RestProcessesEventBasicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessesEventBasicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} processId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessEvent(processId: string, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessEventIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessEvent(processId, processEventPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventBasicApi.createProcessEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessByEventId(processEventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessByEventId(processEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventBasicApi.getProcessByEventId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessEvent(processId: string, processEventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessEvent(processId, processEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventBasicApi.getProcessEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} processId 
         * @param {ProcessEventsSearchRequestDto} processEventsSearchRequestDto Process event search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessEvents(page: number, pageSize: number, processId: string, processEventsSearchRequestDto: ProcessEventsSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessEventsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessEvents(page, pageSize, processId, processEventsSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventBasicApi.getProcessEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessEvent(processId: string, processEventId: number, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessEvent(processId, processEventId, processEventPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventBasicApi.updateProcessEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessesEventBasicApi - factory interface
 */
export const RestProcessesEventBasicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessesEventBasicApiFp(configuration)
    return {
        /**
         * 
         * @param {string} processId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessEvent(processId: string, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventIdDto> {
            return localVarFp.createProcessEvent(processId, processEventPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessByEventId(processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto> {
            return localVarFp.getProcessByEventId(processEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEvent(processId: string, processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventDto> {
            return localVarFp.getProcessEvent(processId, processEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} processId 
         * @param {ProcessEventsSearchRequestDto} processEventsSearchRequestDto Process event search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEvents(page: number, pageSize: number, processId: string, processEventsSearchRequestDto: ProcessEventsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventsPageableResponseDto> {
            return localVarFp.getProcessEvents(page, pageSize, processId, processEventsSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessEvent(processId: string, processEventId: number, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessEvent(processId, processEventId, processEventPropertiesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessesEventBasicApi - interface
 */
export interface RestProcessesEventBasicApiInterface {
    /**
     * 
     * @param {string} processId 
     * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessEvent(processId: string, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventIdDto>;

    /**
     * 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessByEventId(processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto>;

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessEvent(processId: string, processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventDto>;

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} processId 
     * @param {ProcessEventsSearchRequestDto} processEventsSearchRequestDto Process event search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessEvents(page: number, pageSize: number, processId: string, processEventsSearchRequestDto: ProcessEventsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventsPageableResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessEvent(processId: string, processEventId: number, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessesEventBasicApi - object-oriented interface
 */
export class RestProcessesEventBasicApi extends BaseAPI implements RestProcessesEventBasicApiInterface {
    /**
     * 
     * @param {string} processId 
     * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessEvent(processId: string, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig) {
        return RestProcessesEventBasicApiFp(this.configuration).createProcessEvent(processId, processEventPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessByEventId(processEventId: number, options?: RawAxiosRequestConfig) {
        return RestProcessesEventBasicApiFp(this.configuration).getProcessByEventId(processEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessEvent(processId: string, processEventId: number, options?: RawAxiosRequestConfig) {
        return RestProcessesEventBasicApiFp(this.configuration).getProcessEvent(processId, processEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} processId 
     * @param {ProcessEventsSearchRequestDto} processEventsSearchRequestDto Process event search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessEvents(page: number, pageSize: number, processId: string, processEventsSearchRequestDto: ProcessEventsSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesEventBasicApiFp(this.configuration).getProcessEvents(page, pageSize, processId, processEventsSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventPropertiesDto} processEventPropertiesDto Process event basic creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessEvent(processId: string, processEventId: number, processEventPropertiesDto: ProcessEventPropertiesDto, options?: RawAxiosRequestConfig) {
        return RestProcessesEventBasicApiFp(this.configuration).updateProcessEvent(processId, processEventId, processEventPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }
}

